import { GOSPEL_TAGS } from '@/config/constants';

export const demoLineData = [
	{
		[GOSPEL_TAGS[0].label]: 1,
		[GOSPEL_TAGS[1].label]: 0,
		[GOSPEL_TAGS[2].label]: 0,
	},
	{
		[GOSPEL_TAGS[0].label]: 0,
		[GOSPEL_TAGS[1].label]: 1,
		[GOSPEL_TAGS[2].label]: 0,
	},
	{
		[GOSPEL_TAGS[0].label]: 1,
		[GOSPEL_TAGS[1].label]: 0,
		[GOSPEL_TAGS[2].label]: 1,
	},
	{
		[GOSPEL_TAGS[0].label]: 0,
		[GOSPEL_TAGS[1].label]: 1,
		[GOSPEL_TAGS[2].label]: 1,
	},
];
